import Link from "@/modules/LinkPedido/Index.vue";

export default [
  {
    path: "/pedido/:uuid",
    name: "pedido/:uuid",
    component: Link,
    meta: { title: "Pedido Digital" },
  },
];
